'use strict';

module.exports = function () {
    var getProps = Object.getOwnPropertyNames,
        cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [],
        defProp = Object.defineProperty,
        toSource = Function.prototype.toString,
        create = Object.create,
        hasOwn = Object.prototype.hasOwnProperty,
        funcName = /^\n?function\s?(\w*)?_?\(/; // eslint-disable-line fasec/no-unsafe-regex

    function nameOf(func) {
        var finalFunctionName = 'name' in func
            ? func.name : toSource.call(func).match(funcName)[1],
            underscoreName = '_name' in func
                ? func._name : finalFunctionName;
        return typeof func !== 'function'
            ? '' : underscoreName;
    }

    function define(object, key, value) {
        if (typeof key === 'function') {
            value = key;
            key = nameOf(value).replace(/_$/, '');
        }
        return defProp(object, key, { configurable: true, writable: true, value: value });
    }

    function namedFunction(name, func) {
        // Undo the name-stripping that UglifyJS does
        func._name = name;
        return func;
    }

    var uids = create(null),
        createUID = function () {
            var key = Math.random().toString(36).slice(2);
            return key in uids ? createUID() : uids[key] = key;
        },
        globalID = createUID();


    define(Object, namedFunction('getOwnPropertyNames', function getOwnPropertyNames(obj) {
        var coercedObj = Object(obj), props;
        if (coercedObj.toString && coercedObj.toString() === '[object Window]') {
            try {
                props = getProps(obj);
            } catch (e) {
                props = cachedWindowNames;
            }
        } else {
            props = getProps(obj);
        }
        try {
            if (hasOwn.call(obj, globalID)) {
                props.splice(props.indexOf(globalID), 1);
            }
        } catch (err) {
            return cachedWindowNames;
        }


        return props;
    }));
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/own-property-shim.js
 ** module id = 32
 ** module chunks = 0
 **/